import * as Yup from "yup";

export const accountSettingsValidationSchema = Yup.object({
  nickname: Yup.string().optional(),
  year: Yup.string().required("Please select your birth year"),
  gender: Yup.string().required("Please select your gender"),
  race: Yup.string().required("Please select your race"),
  currentPassword: Yup.string().when("newPassword", {
    is: (val: string) => val && val.length > 0,
    then: (schema) =>
      schema.required("Current password is required to set a new one"),
    otherwise: (schema) => schema.optional(),
  }),
  newPassword: Yup.string()
    .optional()
    .test(
      "password-strength",
      "Must be 8-30 chars, uppercase, lowercase, number and special character",
      (val) => {
        if (!val) return true;
        return (
          val.length >= 8 &&
          val.length <= 30 &&
          /[A-Z]/.test(val) &&
          /[a-z]/.test(val) &&
          /[0-9]/.test(val) &&
          /[^A-Za-z0-9]/.test(val)
        );
      },
    ),
  confirmPassword: Yup.string().when("newPassword", {
    is: (val: string) => val && val.length > 0,
    then: (schema) =>
      schema
        .oneOf([Yup.ref("newPassword")], "Passwords do not match")
        .required("Please confirm your new password"),
    otherwise: (schema) => schema.optional(),
  }),
});
